import React, { useState } from "react";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import { FaPaperPlane } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { addMessage } from "./slices/messageSlice"; // adjust path as needed
import { promotePending } from "./store/thunks/promotePending"; // adjust path as needed
import { buildErrorAuditEvent } from "./services/auditEventBuilder";
import { buildAgentFromContextProvider, buildEntityFromContextPatient } from "./utils/messageUtils";

function QuickResponse({
    selectedComm,
    fetchedProvider,
    communicationService,
    setShowThanksModal,
    onSendLocalReply,
    fhirClient,
    contextProvider,
    setSelectedComm,
    selectMessageById,
    contextPatient,
    fetchedEncounter
}) {
    const [quickReply, setQuickReply] = useState("");
    const dispatch = useDispatch();

    //console.log(fetchedEncounter);

    // Canned responses
    const cannedResponses = [
        "Thank you for the update.",
        "Thanks! Please update when there is a change.",
        "Thank you, please provide more details.",
        "Thanks! I will review and respond shortly.",
    ];

    const handleQuickMessage = async () => {
        if (!quickReply.trim()) return;

        if (!selectedComm || selectedComm.resourceType !== "Communication" || !selectedComm.id) {
            const fallbackMessages = selectedComm?.injectedMessages;
            const lastValidMessage = Array.isArray(fallbackMessages)
                ? fallbackMessages[fallbackMessages.length - 1]
                : null;
            if (lastValidMessage?.resourceType === "Communication" && lastValidMessage.id) {
                setSelectedComm(lastValidMessage);
            } else return;
        }

        try {
            const anchorRef = selectedComm.partOf?.[0]?.reference || `Communication/${selectedComm.id}`;
            const response = await communicationService.sendReply(selectedComm, quickReply.trim(), contextProvider);

            // Remove extension from the optimistic message to avoid premature read receipts
            const { extension, ...responseWithoutExtension } = response;

            const optimisticMsg = {
                ...responseWithoutExtension,
                partOf: [{ reference: anchorRef }],
                meta: { isPending: true, sentFromForm: true }
            };

            dispatch(addMessage(optimisticMsg));

            console.log(optimisticMsg);
            
            if (typeof onSendLocalReply === "function") onSendLocalReply(optimisticMsg);

            dispatch(promotePending(anchorRef, fhirClient));
            setQuickReply("");
            setShowThanksModal(false);

            //if (response?.id && typeof selectMessageById === "function") selectMessageById(response.id);

        } catch (error) {
            console.error("Error sending quick response:", error);

            try {
                const agent = buildAgentFromContextProvider(contextProvider);
                const entity = buildEntityFromContextPatient(contextPatient);

                const auditEvent = buildErrorAuditEvent({
                    errorType: "quick-message",
                    error: {
                        message: error?.message || "Failed to send quick message",
                        status: error?.status || error?.response?.status || 500
                    },
                    agent,
                    entity,
                    description: "Error sending quick message"
                });

                if (window.logEvent) window.logEvent(auditEvent);
                else console.log("AuditEvent (quick message error):", auditEvent);
            } catch (logErr) {
                console.error("Failed to log audit event:", logErr);
            }
        }
    };

    return (
        <div className="d-flex justify-content-between align-items-center my-3">
            <InputGroup style={{ maxWidth: "50%" }}>
                <FormControl
                    list="quick-replies-list"
                    placeholder="Quick reply..."
                    value={quickReply}
                    onChange={(e) => setQuickReply(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            handleQuickMessage();
                        }
                    }}
                    disabled={!selectedComm || !selectedComm.id}
                />
                <datalist id="quick-replies-list">
                    {cannedResponses.map((resp, idx) => (
                        <option key={idx} value={resp} />
                    ))}
                </datalist>
                <Button
                    variant="primary"
                    onClick={handleQuickMessage}
                    disabled={!quickReply.trim() || !fetchedProvider || !selectedComm || !selectedComm.id}
                >
                    <FaPaperPlane />
                </Button>
            </InputGroup>
        </div>
    );
}

export default QuickResponse;
